import { MUSIC_STYLE } from "../enum";

const musicStyleOptions = [MUSIC_STYLE.ELECTRONIC, MUSIC_STYLE.POP, MUSIC_STYLE.LATIN, MUSIC_STYLE.COUNTRY, MUSIC_STYLE.KPOP, MUSIC_STYLE.NON_PREFERENCE];

export default musicStyleOptions;
